import { useEffect, useState } from "react";
import api from "../../constants/api.js";
import { useNavigate, Link } from "react-router-dom";
import "./posts.css";


function Posts() {
  const [posts, setPosts] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    async function fetchPosts() {
      try {
        const response = await api.get("/posts"); // rota de posts
        if (response.data) {
          setPosts(response.data);
          
        }
      } catch (error) {
        console.log(error.response?.data?.error || "Erro ao buscar posts");
      }
    }

    fetchPosts();
  }, []);

  

  return (
  <div className="container-posts">
            
          


          <div className="posts">

              {posts.length === 0 && <p>Nenhum post encontrado.</p>}

              {posts.map((post) => (
                <Link 
                  key={post.id_post}
                  to={`/posts/${post.id_post}`}
                  className="post-item"
                >
                  <div className="post-thumb">
                    <img src={post.imagem_url} alt={post.titulo} />
                  </div>

                  <h2>{post.titulo}</h2>
                </Link>
              ))}
            </div>
    </div>
  );
}

export default Posts;